export default class RevisionToolGatewayEvent {
}

// Outgoing
RevisionToolGatewayEvent.READY = "RTGE_READY";
RevisionToolGatewayEvent.CONTEXT_CHANGED = "RTGE_CONTEXT_CHANGED";
RevisionToolGatewayEvent.ADDED_TO_CONTEXT = "RTGE_ADDED_TO_CONTEXT";
RevisionToolGatewayEvent.CONTEXT_CLEARED = "RTGE_CONTEXT_CLEARED";

// Incoming
RevisionToolGatewayEvent.REVISION_ADDED = "GGE_REVISION_ADDED";
RevisionToolGatewayEvent.USE_REVISIONS = "GGE_USE_REVISIONS";
RevisionToolGatewayEvent.ACTIVE_REVISION = "GGE_ACTIVE_REVISION";
RevisionToolGatewayEvent.GAME_PAUSED = "GGE_GAME_PAUSED";
